import { useContext, useEffect } from 'react';
import { SocketContext } from './contexts/SocketContext';
import { useLocation } from 'react-router-dom';
import { useNotification } from './contexts/NotificationContext';

// Keeps the notification bell's unread badge live over the socket. It no longer
// pops a real-time toast on each new notification — 2026-07-16: the constant
// popups were overwhelming for admins. The bell + the Notifications view + the
// Requests page are where staff review what happened.
function GlobalNotificationListener() {
  const socket = useContext(SocketContext);
  const { refreshUnreadCount, refreshPendingRequestCount } = useNotification();
  const location = useLocation();

  const userRole = localStorage.getItem('userRole');
  const isAdminOrManager = userRole === 'admin' || userRole === 'manager' || userRole === 'supervisor';

  const isPublicRoute =
    location.pathname.startsWith('/login') ||
    location.pathname.startsWith('/forgot-password') ||
    location.pathname.startsWith('/reset-password');

  const shouldRun = socket && isAdminOrManager && !isPublicRoute;

  useEffect(() => {
    if (!shouldRun || !refreshUnreadCount) return;
    refreshUnreadCount();
    // Keep the sidebar "Requests" badge (pending requests + non-card deposits)
    // in sync on mount too.
    if (refreshPendingRequestCount) refreshPendingRequestCount();
  }, [shouldRun, refreshUnreadCount, refreshPendingRequestCount]);

  useEffect(() => {
    if (!shouldRun) return;

    const handleNotification = () => {
      // Refresh the unread badge only — no toast popup.
      refreshUnreadCount();
      // A new client submission (request or deposit) fires this too, so keep
      // the Requests badge live alongside the bell.
      if (refreshPendingRequestCount) refreshPendingRequestCount();
    };

    socket.on('new-notification', handleNotification);
    return () => socket.off('new-notification', handleNotification);
  }, [shouldRun, socket, refreshUnreadCount, refreshPendingRequestCount]);

  return null;
}

export default GlobalNotificationListener;
